// extracted by mini-css-extract-plugin
module.exports = {"rich-text-code":"RichTextCode_rich-text-code__Hsd6K"};